import { TChatUiModel } from './chat-ui.types';
import { CHAT_UI_TASKS } from './chat-ui.tasks';

export const CHAT_UI_PIPELINE = {
  addNewQueryPipeline: function <T>(filterGroup: TChatUiModel<T>): TChatUiModel<T> {
    return [CHAT_UI_TASKS.resetQueryText, CHAT_UI_TASKS.applySendQueryOptions, CHAT_UI_TASKS.logChatUiModel].reduce(
      (acc, v) => v(acc),
      filterGroup,
    );
  },
  addNewResponsePipeline: function <T>(filterGroup: TChatUiModel<T>): TChatUiModel<T> {
    return [CHAT_UI_TASKS.applyReceiveResponseOptions, CHAT_UI_TASKS.logChatUiModel].reduce(
      (acc, v) => v(acc),
      filterGroup,
    );
  },
  updateQueryPipeline: function <T>(filterGroup: TChatUiModel<T>): TChatUiModel<T> {
    return [CHAT_UI_TASKS.applyUpdateQueryOptions, CHAT_UI_TASKS.logChatUiModel].reduce(
      (acc, v) => v(acc),
      filterGroup,
    );
  },
};
